import ProfilePhoto from './ProfilePhoto';

export default ProfilePhoto;
